import { Divider, Grid } from '@mui/material'
import React, { useContext } from 'react'
import { CHRONOX_FEATURES, getValidUrl, isAdmin, isFeatureDisabled } from '../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../../assets/styles/global.module.scss";
import ThreadTagComponent from '../threadTag/threadTagComponent';
import ThreadNoteComponent from '../threadNote/threadNoteComponent';
import TicketHistory from '../threadTicket/ticketHistory';
import { useRuleBasedInboxStore } from '../../../../../store/ruleBasedInboxStore';
import { useShallow } from 'zustand/react/shallow';
import clsx from "clsx";

interface InfoTabContentProps {
    renderNoInfoAvailableBlock: (text: string) => JSX.Element
}

const renderInfoInKeyValuePair = (key: string, value: string) => {
    return (
        <Grid item mt={1} className={styles.userLastMessageEntries}>
            <Grid container direction={"column"}>
                <Grid item className={styles.messageEntryTitle}>{key}&nbsp;</Grid>
                <Grid item className={styles.messageEntryValue}>
                    {['chatbot domain']?.includes(key?.toLowerCase()) ?
                        <a
                            href={getValidUrl(value)}
                            target='_blank'
                            rel="noopener noreferrer"
                        >
                            {value}
                        </a>
                        :
                        value
                    }
                </Grid>
            </Grid>
        </Grid>
    );
}

const renderInfo = (key: string, value: string) => {
    if (value) {
        return renderInfoInKeyValuePair(key.split('_').join(' '), value);
    } else {
        return <></>;
    }
}

const InfoTabContent = (props: InfoTabContentProps) => {
    const { renderNoInfoAvailableBlock } = props
    const { userDetail } = useContext(UserContext) as UserContextPayload

    const { isFlagNewThread, sourceDetails } = useRuleBasedInboxStore(useShallow((state) => {
        const thread = state.currentActiveChatbotThread;
        return {
            isFlagNewThread: Boolean(thread),
            sourceDetails: state.sourceDetails,
        };
    }))

    const innerHeight = window.innerHeight - 200;

    return (
        <Grid item id="infoTab" className={globalStyles.overflowAuto} sx={{ height: `${innerHeight}px`, maxHeight: `${innerHeight}px` }}>
            <Grid container direction={"column"}>
                {Object.entries(sourceDetails).length > 0 ? Object.entries(sourceDetails).map(([key, value]: [string, any], ind: number) => {
                    return (
                        <React.Fragment key={ind}>
                            {key == "playground_url" ?
                                isAdmin(userDetail) &&
                                <Grid item mt={1} className={styles.userLastMessageEntries}>
                                    <a className={clsx(globalStyles.primaryFontSize, globalStyles.primaryFontWeight)} href={value} target="_blank">
                                        {`View thread in AI Platform`}
                                    </a>
                                </Grid>
                                :
                                (key == "User_input_token" || key == "User_output_token") ?
                                    null
                                    :
                                    renderInfo(key, value)
                            }
                        </React.Fragment>
                    )
                })
                    :
                    renderNoInfoAvailableBlock("No information available.")
                }

                {isFlagNewThread &&
                    <Grid item mt={2}>
                        <Grid container direction={"column"}>
                            <Grid item>
                                <Divider />
                            </Grid>
                            {!isFeatureDisabled(userDetail, CHRONOX_FEATURES['THREAD_TICKETING']) &&
                                <Grid item>
                                    <TicketHistory />
                                </Grid>
                            }
                            <Grid item>
                                <ThreadTagComponent />
                            </Grid>
                            <Grid item>
                                <ThreadNoteComponent />
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

export default InfoTabContent
